import { INavBarProps } from "./NavBar.types";
import NavBarContainer from "./NavBar.container";
import React from "react";

const NavBar: React.FC<INavBarProps & any> = props => (
  <NavBarContainer {...props}>NavBar</NavBarContainer>
);

export default NavBar;
